import { api } from '@/core/api/';

const URL = 'api/visit';

export const getInitFilters = () => api.get(`${URL}/initfilters`);

export const searchContractVisits = (
  contractId,
  academicYearId,
  monthNumber,
  year
) =>
  api.get(`${URL}/searchcontractvisits/${contractId}`, {
    params: {
      academicYearId,
      monthNumber,
      year,
    },
  });

export const getVisitValidForReposition = (
  academicYearId,
  contractId,
  studentSieId,
  serviceTypeId,
  disciplineTypeId,
  year,
  monthNumber
) =>
  api.get(
    `${URL}/searchvisitvalidforreposition/${academicYearId}/${contractId}/${studentSieId}/${serviceTypeId}/${disciplineTypeId}/${year}/${monthNumber}`
  );

export const createvisit = (payload) =>
  api.post(`${URL}/createvisit`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const updateVisit = (payload) =>
  api.put(`${URL}/updatevisit`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const updateVisitSummary = (payload) =>
  api.put(`${URL}/updatevisitsummary`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getVisitValidationInfo = (
  contractId,
  academicYearId,
  monthDate,
  specialistId,
  companyId
) =>
  api.get(`${URL}/visitvalidationinfo`, {
    params: {
      contractId,
      academicYearId,
      monthDate,
      specialistId,
      companyId,
    },
  });

export const getIsValidVisitFrecuency = (
  frecuencyId,
  contractId,
  visitDate,
  isAbsence
) =>
  api.get(`${URL}/validatevisitfrecuency`, {
    params: {
      frecuencyId,
      contractId,
      visitDate,
      isAbsence,
    },
  });

export const getIsValidVisitAssitantHours = (
  contractId,
  visitDate,
  visitTimeStart,
  visitTimeEnd,
  visitTimeContinuedStart,
  visitTimeContinuedEnd,
  studentSieId,
  academicYear,
  visitId,
  isTherapyABA,
  visitIsCompensatory,
  visitTypeId
) =>
  api.get(`${URL}/validatevisitassistantypehours`, {
    params: {
      contractId,
      visitDate,
      visitTimeStart,
      visitTimeEnd,
      visitTimeContinuedStart,
      visitTimeContinuedEnd,
      studentSieId,
      academicYear,
      visitId,
      isTherapyABA,
      visitIsCompensatory,
      visitTypeId,
    },
  });

export const getInterventionPlanInfo = (contractId) =>
  api.get(`${URL}/interventionplaninfo/${contractId}`);

export const deleteVisit = (visitId) => api.put(`${URL}/delete/${visitId}`);

export const hasFinalizedPeriod = (
  academicYearId,
  monthNumber,
  companyId,
  specialistId,
  contractId,
  year
) =>
  api.get(`${URL}/hasfinalizedperiod`, {
    params: {
      academicYearId,
      monthNumber,
      companyId,
      specialistId,
      contractId,
      yearNumber: year,
    },
  });

export const updateVisitSummaryChangeStatus = (payload) =>
  api.put(`${URL}/changestatusvisitsummaryedocument`, payload);

export const cancelVisitElectronicsSignature = (visitSummaryId, reason) =>
  api.post(`${URL}/cancelelectronicsignature`, { visitSummaryId, reason });

export const getPreviousYearAndCompensatoryIdsForRegisterVisit = async (
  studentSieId,
  disciplineTypeId
) => {
  return await api.get(
    `api/providers/compensatoryrequest/yearsandcompensatoriesforvisitregistry/${studentSieId}/${disciplineTypeId}`
  );
};

export const getFeeScheduleCpt = async (studentServiceId) => {
  return await api.get(`${URL}/fee-schedule-cpt/${studentServiceId}`);
};
export const getSupervisors = async (specialistId) => {
  return await api.get(`${URL}/supervisor/${specialistId}`);
};
